export default {
  subheadline: 'Skonfiguruj usługi powiadomień',
};
